import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { KeycloakAuthService } from '../services/keycloak-auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private keycloakAuth: KeycloakAuthService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    try {
      const isLoggedIn = await this.keycloakAuth.isLoggedIn();
      if (isLoggedIn) {
        await this.keycloakAuth.updateToken(5);
        return true;
      }
      this.keycloakAuth.login();
      return false;
    } catch (error) {
      console.error('[AuthGuard] Erreur:', error);
      this.keycloakAuth.login();
      return false;
    }
  }
}